import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Row,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { formatBytes } from '../../../helpers/Files';

const AdminPaymentComplimentary = ({ client }) => {
  const intl = useIntl();

  return (
    <Row className="payment-plan">
      <Col>
        <Row>
          <Col lg="6" className="plan-content">
            <div className="plan-header">
              <h4 className="plan-name">
                {intl.formatMessage({ defaultMessage: 'Complimentary account' })}
              </h4>
              <p className="plan-details">
                {
                  intl.formatMessage({
                    defaultMessage: 'Unlimited Users + {storage} of Storage',
                  }, { storage: formatBytes(client.file_size_limit) })
                }
              </p>
            </div>
            <div className="plan-body">
              <p>
                {
                  intl.formatMessage({
                    defaultMessage: 'Your current usage: <strong>{usedStorage}</strong>',
                  }, { usedStorage: formatBytes(client.used_storage) || 0 })
                }
              </p>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

AdminPaymentComplimentary.propTypes = {
  client: PropTypes.object.isRequired,
};

export default AdminPaymentComplimentary;
